:host {
  display: block;
}

.sportsline-pick-snippet-parlay--loading {
  display: grid;
  place-items: center;
}
